import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import errorHandle from '../../utils/errorHandle';
import axios from 'axios';
import authContext from '../../context/authContext/authContext';
import Loader from '../../utils/Loader';
import PartnerStatus from '../PartnerStatus';


const GET_USER_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/get-user";
const initialState = { user: {}, loading: false }


const UserDetailsModal = ({ reqUserId, isOpen, toggle }) => {
  const { getConfig } = useContext(authContext)
  const [state, setCompleteState] = useState(initialState);
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const onHideModal = () => {
    setState(initialState)
    toggle();
  }

  const getUser = async () => {
    if (state.loading) {
      return;
    }

    setState({ loading: true })
    const config = getConfig()
    const data = { reqUserId: reqUserId }
    await axios.post(GET_USER_API_END_POINT, data, config)
      .then((res) => {
        const { user } = res.data
        setState({ loading: false, user })
      })
      .catch((err) => {
        setState({ loading: false })
        onHideModal();
        errorHandle(err)
      })
  }

  useEffect(() => {
    if (reqUserId && isOpen) {
      getUser();
    }
  }, [reqUserId, isOpen])


  const closeBtn = () => <button className='btn btn-close' onClick={onHideModal}>X</button>;

  return (
    <Modal isOpen={isOpen} toggle={onHideModal} size='md'>
      <ModalHeader toggle={onHideModal} close={closeBtn()}>
        <div className='d-flex align-items-center'>
          <div>User</div>
          <div className='ml-3'>
            <Loader isLoading={state.loading} />
          </div>
        </div>
      </ModalHeader>
      <ModalBody className=''>
        <div className=''>
          <table className="table-auto w-100 border">
            <tbody>
              <tr className="border-b">
                <td className="p-2 fw-500">User ID</td>
                <td className="p-2">{state?.user?._id || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">Name</td>
                <td className="p-2">{state?.user?.name || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">Email</td>
                <td className="p-2">{state?.user?.email || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">Phone</td>
                <td className="p-2">{state?.user?.phone || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">Address</td>
                <td className="p-2">{state?.user?.address || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">Answer</td>
                <td className="p-2">{state?.user?.answer || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">DOB</td>
                <td className="p-2">{state?.user?.dob || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">Aadhar</td>
                <td className="p-2">{state?.user?.aadhar || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">PAN</td>
                <td className="p-2">{state?.user?.pan || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">Nominee</td>
                <td className="p-2">{state?.user?.nominee || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">Client ID</td>
                <td className="p-2">{state?.user?.clientId || '-'}</td>
              </tr>

              <tr className="border-b">
                <td className="fw-500 p-2">Partner Ratings</td>
                <td className="p-2">{state?.user?.partnerRating ? <span>{state?.user?.partnerRating}/5</span> : '-'}</td>
              </tr>

              <tr>
                <td className="fw-500 p-2">Partner</td>
                <td className="p-2">
                  <PartnerStatus isPartner={state?.user?.isPartner || '-'} />
                </td>
              </tr>

              <tr>
                <td className="fw-500 p-2">Demat</td>
                <td className="p-2">
                  <PartnerStatus isPartner={state?.user?.clientId || '-'} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={state.loading}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default UserDetailsModal
